import { SellerApiOneC } from 'components/sellers/SellerApiOneC/SellerApiOneC'
import { useAppSelector } from 'shared/hooks/useReduxHooks'
import { appSelectors } from 'store/app'

export const ProfileApiOneC: React.FC = () => {
  const sellerId = useAppSelector(appSelectors.selectSellerId)
  return <SellerApiOneC type='profile' sellerId={sellerId ?? ''} />
}
